/* eslint-disable */
// lint to be fixed in this ticket: https://lastbrand.atlassian.net/browse/ECOMP-3295
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/order */
/*
 * TODO: IMPORTANT IMPORTANT IMPORTANT
 * DO NOT CHANGE THE ORDER OF IMPORTS HERE IT WILL BREAK THE BUILD
 *
 * import { getCartAuthCodeFromHeader } from '../../../services/cartService/cart.service.helper'
 */
import { LOCAL_STORAGE_NEW_CART_ID_KEY } from '../../../services/checkoutService/new-checkout.constants'
import { getCartAuthCodeFromHeader } from '../../../services/cartService/cart.service.helper'

import { LineItemDetails } from '@src/quince-site-common/src/organisms/appLayout/molecules/cartPopUp/cart.helper'
import {
  Cart,
  CartLineItem,
  PromoAllocation,
} from '@src/quince-site-common/src/services/cartService/cart.service.types'

import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { INVENTORY_STATUS } from '@src/quince-site-common/src/services/cartService/cart.service.constants'
import { getStorage } from '@src/utils/enhancedStorage'
import { getSvdExperimentValue } from '@src/experiments/statsig-integration/get-svd-experiment-value'

export function getLineItem(newCheckout: Cart) {
  return newCheckout?.lineItems
}

export function getLineItemId(lineItem: CartLineItem) {
  return lineItem?.variantId
}

export function getSvidFromEdge(edge: CartLineItem) {
  return edge?.productMetaData?.svid
}

export function getSpid(lineItem?: CartLineItem) {
  return lineItem?.productMetaData?.spid
}

export function getSelectedOptionsFromLineItem(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.options
}

export function getLineItemsSubtotalPriceAmount(node?: Cart) {
  return node?.cartCostSummary?.subTotalAmount
}
export function getLineItemsCurrencyCode(node: Cart) {
  return node?.currencyCode || ''
}

export function getSubtotalPriceV2(node: Cart) {
  return node?.cartCostSummary?.totalAmount
}

export function getLineItemEdges(node: Cart) {
  return node?.lineItems
}

export function getSaveForLaterItems(node: Cart) {
  return node?.saveForLaterItems
}

export function getOutOfStockItems(node: Cart) {
  return node?.outOfStockLineItems || []
}

export function getProductID(lineItem?: CartLineItem) {
  return lineItem?.variantMetaData?.productId
}

export function getVariantId(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.variantId
}

export function getSvid(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.svid
}

export function getVariantSelectedOptions(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.options
}

export function getVariantIdFromEdge(edge: CartLineItem) {
  return edge?.variantId
}

export function getVariantProductIdFromEdge(edge: any) {
  return edge?.lineItem?.variantId
}

export function getVariantProductId(node: any) {
  return node?.lineItem?.variantId
}

export function getIdFromEdge(edge: CartLineItem) {
  return edge.id
}

export function getQuantityFromEdge(edge: CartLineItem): number | undefined {
  return edge?.quantity
}

export function getLineItemFromEdge(edge?: CartLineItem): CartLineItem | undefined {
  return edge
}

export function getLineItemDetails(lineItems: CartLineItem[]): Record<string, LineItemDetails> {
  return lineItems.reduce((acc: Record<string, LineItemDetails>, curr) => {
    const { variantId: internalVariantId, productId: internalProductId, price } = curr.variantMetaData || {}

    const variantTitle = curr.variantMetaData?.variantTitle || ''
    const splitVariantTitle = variantTitle.split(' / ')
    const hasSizeAndColor = splitVariantTitle.length > 1
    const color = hasSizeAndColor ? splitVariantTitle[1] || '' : ''
    const size = hasSizeAndColor ? splitVariantTitle[0] || '' : ''
    const ignoredVariants = [...ignoredVariantsUS, ...ignoredVariantsCA].map(variant => variant.toLowerCase())

    let productLink = curr.slug ? `/${curr.slug}` : ''
    if (productLink) {
      const queryParams: string[] = []

      if (color) {
        queryParams.push(`color=${encodeURIComponent(color.toLowerCase())}`)
      }
      if (size && !ignoredVariants.includes(size.toLowerCase())) {
        queryParams.push(`size=${encodeURIComponent(size.toLowerCase())}`)
      }

      if (queryParams.length > 0) {
        productLink += `?${queryParams.join('&')}`
      }
    }

    return {
      ...acc,
      [curr.variantId]: {
        productLink,
        internalVariantId,
        internalProductId,
        price,
      },
    }
  }, {})
}

export function getIsAnyItemOutOfStock(lineItems: any[]) {
  return lineItems?.some(
    lineItem =>
      lineItem?.inventoryStatus === INVENTORY_STATUS.OUT_OF_STOCK ||
      lineItem?.inventoryStatus === INVENTORY_STATUS.PARTIAL_OUT_OF_STOCK,
  )
}

type LineItemInventoryFields = {
  inventoryData?: {
    available?: number
    tags?: {
      preOrderShippingDate?: string
    }
  }
}

export function getQuantityAvailableFromLineItem(lineItem: LineItemInventoryFields) {
  return lineItem?.inventoryData?.available
}

export function getProductFromLineItem(lineItem: CartLineItem) {
  return lineItem?.variantMetaData
}

export function getProductTitleFromLineItem(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.productTitle
}

const ignoredVariantsUS: string[] = ['One Size', 'default', 'One Color', 'No Color']
const ignoredVariantsCA: string[] = [
  // fr-ca
  'Taille unique',
  'par défaut',
  'Une couleur',
  'Aucune couleur',

  // for en-ca
  'One Size',
  'default',
  'One Colour',
  'No Colour',
]

export function getVariantTitleFromLineItem(lineItem: CartLineItem) {
  // replace One Size, default, One Color, No Color with empty string
  // same is being shown in CA as well

  let variantTitle = lineItem?.variantMetaData?.variantTitle || ''

  // replace the changes
  ;[...ignoredVariantsUS, ...ignoredVariantsCA].forEach((variant: string) => {
    const regex = new RegExp(variant, 'gi')
    variantTitle = variantTitle?.replace(regex, '')
  })

  return variantTitle
    ?.split(' / ')
    .filter(title => Boolean(title))
    .join(' / ')
}

/**
 * True when the value is one of the placeholder option values the legacy path strips
 * (case-insensitive) — MSFRNT-5825: they must never render on the VDA path either.
 */
function isIgnoredVariantValue(value: string): boolean {
  const normalized = value.trim().toLowerCase()
  return [...ignoredVariantsUS, ...ignoredVariantsCA].some(ignored => ignored.toLowerCase() === normalized)
}

// Smart Variant / VDA v2: show bucket joins isVda attribute values (vdaConfig.order order) with
// ' | '; hide bucket delegates to getVariantTitleFromLineItem. Falls back to variantTitle when ANY
// isVda value resolves empty (partially/non-migrated SKU — never drop an axis).
/**
 * VDA per-axis display values for the line item, in axis order — `undefined` when any axis is
 * missing a value (non-migrated item), so callers fall back to the legacy `variantTitle`.
 * Placeholder values ("No Color", "One Size", ...) are dropped AFTER that check — they count as
 * present (the SKU is migrated) but are hidden E2E just like the legacy path (MSFRNT-5825), and
 * removing them before the caller's join leaves no dangling separator.
 */
function getVdaVariantDisplayValues(lineItem: CartLineItem): string[] | undefined {
  const meta = lineItem?.variantMetaData
  const attributes = meta?.attributes ?? []
  const attributeValues = meta?.attributeValues ?? {}
  const vdaAttributes = attributes.filter(attr => attr.isVda)
  const values = vdaAttributes
    .slice()
    .sort((a, b) => {
      const posA = a.vdaConfig?.order ?? Number.POSITIVE_INFINITY
      const posB = b.vdaConfig?.order ?? Number.POSITIVE_INFINITY
      return posA - posB
    })
    .map(attr => (attributeValues[attr.key]?.displayValue?.localisedValue || '').trim())

  if (values.length === 0 || values.some(value => !value)) {
    return undefined
  }

  return values.filter(value => !isIgnoredVariantValue(value))
}

export function getVariantDisplayValues(lineItem: CartLineItem, isSmartVariantEnabled: boolean): string {
  if (!isSmartVariantEnabled) {
    return getVariantTitleFromLineItem(lineItem)
  }

  return getVdaVariantDisplayValues(lineItem)?.join(' | ') ?? getVariantTitleFromLineItem(lineItem)
}

/**
 * Display PARTS for renderers that show each variant value as its own segment (or re-join with
 * their own separator). Show bucket returns the discrete VDA values directly, so a `/` INSIDE a
 * value (size "M/L") survives — splitting the joined string can't tell it apart from the legacy
 * title separator, which is exactly how "M/L" used to render as "M | L". Non-migrated items and
 * the hide bucket keep the existing behavior: split the `variantTitle` on the bucket's separator.
 */
export function getVariantDisplayParts(lineItem: CartLineItem, isSmartVariantEnabled: boolean): string[] {
  if (isSmartVariantEnabled) {
    const values = getVdaVariantDisplayValues(lineItem)
    if (values) {
      return values
    }
  }

  return getVariantTitleFromLineItem(lineItem)
    .split(getVariantTitleSeparator(isSmartVariantEnabled))
    .map(part => part.trim())
    .filter(Boolean)
}

// Show bucket splits on ' | ' AND the legacy '/' (its non-migrated fallback); hide bucket keeps '/'.
const SHOW_BUCKET_VARIANT_TITLE_SEPARATORS = /[|/]/
const LEGACY_VARIANT_TITLE_SEPARATOR = '/'

/** Separator DS renderers split the built variant title on. */
export function getVariantTitleSeparator(isSmartVariantEnabled: boolean): RegExp | string {
  return isSmartVariantEnabled ? SHOW_BUCKET_VARIANT_TITLE_SEPARATORS : LEGACY_VARIANT_TITLE_SEPARATOR
}

export function getCustomAttributes(lineItem?: CartLineItem) {
  return lineItem?.attributes || []
}

/**
 * Smart Variant / VDA v2 — the `selected_attributes` event field: the selected value per VDA
 * axis, keyed by the immutable camelCase attribute key with localised display values
 * (`{ color: "Blue", ringSize: "7" }`) — the shape standardized on the card events
 * (STRFRNT-16198). Reads the line item's `variantMetaData` attributes/attributeValues and
 * returns undefined when the line item carries no VDA entries (flag-off / non-migrated SKU),
 * keeping flag-off payloads byte-identical.
 */
export function getSelectedAttributesFromLineItem(lineItem?: CartLineItem): Record<string, string> | undefined {
  // Flag-gated, not just data-gated: the cart API ships `attributes` regardless of the client
  // flag, and the contract is that these event fields exist ONLY for flag-ON sessions.
  if (!getSvdExperimentValue()) return undefined
  const meta = lineItem?.variantMetaData
  const vdaAttributes = (meta?.attributes ?? []).filter(attr => attr.isVda)
  if (vdaAttributes.length === 0) return undefined
  const attributeValues = meta?.attributeValues ?? {}
  const selected: Record<string, string> = {}
  vdaAttributes.forEach(attr => {
    const displayValue = attributeValues[attr.key]?.displayValue
    const value = (displayValue?.localisedValue || displayValue?.value || '').trim()
    if (value) selected[attr.key] = value
  })
  return Object.keys(selected).length > 0 ? selected : undefined
}

/**
 * `selected_attributes` from an SVD-resolved variant (the PDP buy box hands `addToCart` a
 * pre-resolved `SvdProductVariant`): axes come from `variant.vdas` (vdaKey → canonical value
 * key), display values from the hydrated `variant.attributeValues` when present (localised),
 * falling back to the canonical value key. Returns undefined for legacy variants (no `vdas`),
 * keeping flag-off events untouched. Also the flag-ON source for the events' explicit
 * `size`/`color` fields — a product without those axes sends them as undefined by design.
 */
export function getSelectedAttributesFromSvdVariant(variant?: {
  vdas?: Record<string, string>
  attributeValues?: Record<string, { value?: string; localisedValue?: string }>
}): Record<string, string> | undefined {
  const vdas = variant?.vdas
  if (!vdas || Object.keys(vdas).length === 0) return undefined
  const selected: Record<string, string> = {}
  Object.entries(vdas).forEach(([axisKey, valueKey]) => {
    const attributeValue = variant?.attributeValues?.[axisKey]
    const value = (attributeValue?.localisedValue || attributeValue?.value || valueKey || '').trim()
    if (value) selected[axisKey] = value
  })
  return Object.keys(selected).length > 0 ? selected : undefined
}

/**
 * Smart Variant / VDA v2 — the `vdas` event field for the cart-module events
 * (remove_from_cart / save_for_later / move_to_bag per the Smart Variant Events sheet):
 * every VDA axis with its available display values, `{ "<vdaName>": ["Val1", "Val2"] }` —
 * the agreed generalization of the legacy `color_variant` array. Built from the v2-adapted
 * product's synthesized `productOptions` (one option per axis, values in wire order); only
 * emitted while the SVD flag is on so flag-off payloads stay byte-identical.
 */
export function getVdasFromProduct(product?: {
  productOptions?: { name?: string; values?: { value?: string; displayName?: string }[] }[]
}): Record<string, string[]> | undefined {
  if (!getSvdExperimentValue()) return undefined
  const options = product?.productOptions ?? []
  if (options.length === 0) return undefined
  const vdas: Record<string, string[]> = {}
  options.forEach(option => {
    const values = (option.values ?? [])
      .map(optionValue => optionValue.displayName || optionValue.value || '')
      .filter(Boolean)
    if (option.name && values.length > 0) vdas[option.name] = values
  })
  return Object.keys(vdas).length > 0 ? vdas : undefined
}

export function getProductImageFromLineItem(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.imageUrl
}

export function getPreOrderShippingData(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.imageUrl
}

export function getSvMetaField(lineItem: LineItemInventoryFields) {
  const quantityAvailable = getQuantityAvailableFromLineItem(lineItem)

  const { inventoryData } = lineItem
  return {
    svMetaField: inventoryData,
    shippingDate: inventoryData?.tags?.preOrderShippingDate,
    quantityAvailable,
  }
}

export function getVariantPrice(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.price
}

export function getProductTitleFromNode(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.productTitle
}

export function getVariantTitleFromNode(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.variantTitle
}

export function getVariantSkuFromNode(lineItem: CartLineItem) {
  return lineItem?.variantMetaData?.variantTitle
}

export function getVarientId(variant: any) {
  return variant?.id
}

export function isEqualId(id: string, filterIdForVariant: string) {
  return id === filterIdForVariant
}

export function getCartIDAndAuth() {
  return {
    cartID: isBrowser() ? getStorage().getItem(LOCAL_STORAGE_NEW_CART_ID_KEY, { isGlobal: false }) : null,
    authCode: getCartAuthCodeFromHeader(),
  }
}

export const getCheckoutToken = (): string => {
  const { cartID } = getCartIDAndAuth()
  return cartID ?? ''
}

export function getCreatedAt(lineItem: CartLineItem) {
  return lineItem?.createdAt
}

export function getDiscountAllocations(lineItem: CartLineItem): PromoAllocation[] {
  return (
    lineItem?.costSummary?.promoAllocations.filter(
      promoAllocation =>
        promoAllocation.promoType === 'MONEY_DISCOUNT' || promoAllocation.promoType === 'SUBSCRIPTION_DISCOUNT',
    ) || []
  )
}

export function getDiscountTitle(allocation: PromoAllocation, tCommon: any) {
  if (allocation.promoType === 'SUBSCRIPTION_DISCOUNT' && tCommon) {
    return tCommon('subscribe_and_save')
  }
  return allocation?.promoCode
}

export function getDiscountAmount(allocation: PromoAllocation) {
  return allocation?.amount
}

/**
 * Get subscription discount amount for a line item
 * @param lineItem - The cart line item
 * @returns The subscription discount amount, or 0 if none
 */
export function getSubscriptionDiscount(lineItem: CartLineItem): number {
  const subscriptionAllocation = lineItem?.costSummary?.promoAllocations.find(
    alloc => alloc.promoType === 'SUBSCRIPTION_DISCOUNT',
  )
  return subscriptionAllocation?.amount ?? 0
}

const DEFAULT_MAX_QUANTITY = 50
const DEFAULT_SUBSCRIPTION_MAX_QUANTITY = 10

export function getMaxQuantity(lineItem: CartLineItem): number {
  if (lineItem.purchaseMode === 'RECURRING') {
    return lineItem.variantMetaData?.subscriptionMaxQuantity ?? DEFAULT_SUBSCRIPTION_MAX_QUANTITY
  }
  return DEFAULT_MAX_QUANTITY
}

export function getSkuTotalQuantityInCart(lineItem: CartLineItem, allLineItems: CartLineItem[] | undefined): number {
  const sku = lineItem.variantMetaData?.sku
  if (!sku || !allLineItems?.length) return lineItem.quantity ?? 0
  return allLineItems.reduce((sum, li) => (li.variantMetaData?.sku === sku ? sum + (li.quantity ?? 0) : sum), 0)
}

export function isSkuMaxQuantityReached(lineItem: CartLineItem, allLineItems: CartLineItem[] | undefined): boolean {
  return getSkuTotalQuantityInCart(lineItem, allLineItems) >= getMaxQuantity(lineItem)
}

export function isSubscriptionLineItem(lineItem: CartLineItem): boolean {
  return lineItem.purchaseMode === 'RECURRING'
}

export function isSubscriptionEligible(lineItem: CartLineItem): boolean {
  return lineItem.purchaseMode !== 'RECURRING' && lineItem.variantMetaData?.isSubscribable === true
}

export function getSpidForLineItem(lineItem: CartLineItem) {
  return lineItem?.productMetaData?.spid
}

export function getSwatchesId(lineItem: any) {
  return lineItem?.variantId
}
export function getSwatchesIdFromLineItem(lineItem: any) {
  return lineItem?.variantId
}
export const getpayloadForRemoveLineItems = (lineItem: any) => {
  return {
    lineItemId: getIdFromEdge(lineItem),
    adjustment: -1,
  }
}

export function getSubscriptionFrequencyLabel(
  plans: Array<{ id?: number; planId?: number; frequency: { interval: number; unit: string } }> | undefined,
  targetPlanId: number | null | undefined,
): string | null {
  if (!plans || !targetPlanId) return null
  const plan = plans.find(p => (p.id ?? p.planId) === targetPlanId)
  return plan ? `${plan.frequency.interval} ${plan.frequency.unit}` : null
}

export function getProductPayload(
  lineItems: CartLineItem[] = [],
  position: 'active' | 'saved_for_later' | 'out_of_stock' = 'active',
) {
  if (!lineItems) return []
  return lineItems.map((item, index) => {
    return {
      product_id: item.productMetaData?.spid ?? item.variantMetaData?.productId,
      variant_id: item.variantId,
      quantity: item.quantity,
      price: item.costSummary?.totalAmount,
      is_of_subscription_nature: item.purchaseMode === 'RECURRING',
      subscription_frequency: getSubscriptionFrequencyLabel(
        item.variantMetaData?.plans,
        item.subscriptionDetail?.subscriptionPlanId,
      ),
      product_position: position,
      page_number: index + 1,
      item_added_at_timestamp: item.latestAddedToCartAt ?? item.createdAt,
    }
  })
}

/* eslint-enable */
